export const questionModule = {
  state: {
    question: {},
    surveyId: "survey-01",
    clientId: "client-example-23",
    contextMenuActive: false,
    contextPosition: {}
  },
  mutations: {
    setSurveyId(state, id) {
      state.surveyId = id;
    },
    setClientId(state, id) {
      state.clientId = id;
    },
    setId(state, id) {
      state.question = { "id": id };
    },
    setRoot(state, isRoot) {
      state.question.root = isRoot;
    },
    closeActionMenu(state) {
      state.contextMenuActive = false;
    },
    makeActionMenuActive(state, position) {
      state.contextPosition = { "left": position.xPos + "px", "top": position.yPos + "px" };
      state.contextMenuActive = true;
    }
  },
  actions: {
    loadSurvey({ commit }, { clientId, surveyId }) {
      commit("setClientId", clientId);
      commit("setSurveyId", surveyId);
    },
    setId({ commit }, { id, root }) {
      commit("setId", id);
      commit("setRoot", root);
      commit("closeActionMenu");
    },
    setIdOnly({ commit }, { id }) {
      commit("setId", id);
    },
    closeActionMenu({ commit }) {
      commit("closeActionMenu");
    },
    showActionMenu({ commit }, position) {
      commit("makeActionMenuActive", position);
    }
  },
  getters: {
    clientId: (state) => {
      return state.clientId;
    },
    surveyId: (state) => {
      return state.surveyId;
    },
    selectedId: (state) => {
      return state.question?.id;
    },
    selectedSurvey: (state) => {
      return state.surveyId;
    },
    selectedClient: (state) => {
      return state.clientId;
    },
    contextMenuIsOpen: (state) => {
      return state.contextMenuActive;
    }
  }
};
